import React from 'react';
import { FaCheckCircle, FaClock, FaMapMarkerAlt, FaUser, FaUsers } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const StatusDisplay = ({ ride, currentUser, otherUser, userRole, otherUserRole }) => {
  const { t } = useTranslation('common');

  // If no ride, show minimal state
  if (!ride) {
    return (
      <div className="RAC-status-display-compact">
        <span className="RAC-user-role">{userRole}</span>
      </div>
    );
  }

  // Get meeting time display
  const getMeetingTime = () => {
    if (!ride.meeting_time) return null;
    const meetingTime = new Date(ride.meeting_time);
    const timeString = meetingTime.toLocaleTimeString([], { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
    return (
      <div className="RAC-meeting-time-compact">
        <FaClock size={10} />
        <span>{timeString}</span>
      </div>
    );
  };

  // Get arrival status - more compact
  const getArrivalStatus = () => {
    if (!ride.driver_arrival_time && !ride.passenger_arrival_time) {
      return null;
    }

    const driverArrived = !!ride.driver_arrival_time;
    const passengerArrived = !!ride.passenger_arrival_time;

    return (
      <div className="RAC-arrival-status-compact">
        <span className={`RAC-status-indicator ${driverArrived ? 'RAC-arrived' : 'RAC-waiting'}`}>
          {t('ride_actions.driver')}: {driverArrived ? '✓' : '○'}
        </span>
        <span className={`RAC-status-indicator ${passengerArrived ? 'RAC-arrived' : 'RAC-waiting'}`}>
          {t('ride_actions.passenger')}: {passengerArrived ? '✓' : '○'}
        </span>
      </div>
    );
  };

  // Get timer display - compact
  const getTimerDisplay = () => {
    if (ride.status !== 'waiting_for_other' || !ride.timer_started_at) {
      return null;
    }

    const startTime = new Date(ride.timer_started_at);
    const now = new Date();
    const elapsedSeconds = Math.floor((now - startTime) / 1000);
    const totalSeconds = (ride.meeting_duration_minutes || 3) * 60;
    const remainingSeconds = Math.max(0, totalSeconds - elapsedSeconds);

    if (remainingSeconds <= 0) {
      return (
        <div className="RAC-timer-display-compact RAC-expired">
          <FaClock size={10} />
          <span>{t('ride_actions.expired')}</span>
        </div>
      );
    }

    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;

    return (
      <div className="RAC-timer-display-compact">
        <FaClock size={10} />
        <span>{minutes}:{seconds.toString().padStart(2, '0')}</span>
      </div>
    );
  };

  return (
    <div className="RAC-status-display-compact">
      <div className="RAC-status-header-compact">
        <span className="RAC-user-role">{userRole}</span>
        {otherUser && (
          <span className="RAC-other-user-compact">
            {t('ride_actions.vs')} {otherUser.username || t('ride_actions.user')}
          </span>
        )}
      </div>
      
      <div className="RAC-status-content-compact">
        {getMeetingTime()}
        {getArrivalStatus()}
        {getTimerDisplay()}
      </div>
    </div>
  );
};

export default StatusDisplay;